import React from 'react'
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import { Box, Text } from 'rebass'
import { Heading } from '../../components/Text'
import Layout from '../../components/layout'
import { ColorOverlay } from '../../components/ui/ColorOverlay'
import SEO from '../../components/seo'

const PageHeading = ({ children, ...props }) => (
  <Text as="h3" pb={0} mb={0} {...props}>
    {children}
  </Text>
)

PageHeading.propTypes = {
  children: PropTypes.node,
}
/* eslint-disable */
const options = {
  renderMark: {
    [MARKS.BOLD]: text => <Text as="strong" fontWeight="bold">{text}</Text>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Text as="p">{children}</Text>,
    [BLOCKS.HEADING_1]: (node, children) => <PageHeading as="h1">{children}</PageHeading>,
    [BLOCKS.HEADING_2]: (node, children) => <PageHeading as="h2">{children}</PageHeading>,
    [BLOCKS.HEADING_3]: (node, children) => <PageHeading as="h3">{children}</PageHeading>,
    [BLOCKS.HEADING_4]: (node, children) => <PageHeading as="h4">{children}</PageHeading>,
    [BLOCKS.HEADING_5]: (node, children) => <PageHeading as="h5">{children}</PageHeading>,
    [BLOCKS.HEADING_6]: (node, children) => <PageHeading as="h6">{children}</PageHeading>,
    [INLINES.ASSET_HYPERLINK]: node =>
      `<img class='custom-asset' src="${
        node.data.target.fields.file['en-US'].url
      }"/>`,
    [INLINES.EMBEDDED_ENTRY]: node => (
      <a href={node.data.target.fields.link['en-US']}>
        {node.data.target.fields.title['en-US']}
      </a>
    ),
  },
};
/* eslint-enable */

const d = ({ description }) => documentToReactComponents(JSON.parse(description.description), options)

const SecondPage = ({ pageContext }) => {
  const a = d(pageContext)
  return (
    <Layout invertMenuLogo>
      <SEO title={pageContext.title} />
      <Box
        width={[1, 1, 2 / 3]}
        mx={[0, 0, 'auto']}
        color="white"
        pt={[3, 4]}
        pb={6}
        css={css`
          max-width: 880px;
          z-index: 1;
          position: relative;
        `}
      >
        <Box ml={[4, 5, 6, 7]}>
          <Heading as="h1">{pageContext.title}</Heading>
          <div>{a}</div>
        </Box>
      </Box>
      <ColorOverlay />
    </Layout>
  )
}

SecondPage.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

export default SecondPage
